module.exports = __webpack_public_path__ + "media/img/favicon-96x96-a9e8a6726c647bd5e80131ee9d07f79d.png";